import React, { useEffect, useRef } from 'react'
import { Button, Typography, Box } from '@mui/material'
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked'
import { BiChevronRight } from 'react-icons/bi'
import Lottie from 'lottie-react'

import stDesk from './stylesBA'
import { checkAnimated } from '../../../assets'

export default function ButtonAction({
  title,
  titleLabel,
  onClick,
  confirmed,
  Icon = null,
  disabled = false,
  text = null,
  pay = '',
  unavailableMessage = '', // nova prop
  sx = {},
}) {
  const lottieRef = useRef(null)

  useEffect(() => {
    const interval = setInterval(() => {
      if (lottieRef.current) {
        lottieRef.current.setSpeed(4)
        clearInterval(interval)
      }
    }, 100)
    return () => clearInterval(interval)
  }, [confirmed])

  return (
    <Box sx={{ width: '100%', mt: 'var(--margin-low)' }}>
      <Button
        variant='outlined'
        onClick={onClick}
        disabled={disabled}
        sx={[stDesk.containBttDefault, sx, disabled && stDesk.disabledButton, { width: '100%' }]}
      >
        {pay === 'payMetod' && <img style={stDesk.imgIcon} src={Icon} alt='' />}
        {title && Icon && <Icon size={25} color='#DA5A34' style={stDesk.iconLeft} />}

        <Box sx={stDesk.containLabels}>
          <Typography sx={stDesk.textTitle}>{titleLabel}</Typography>
          {text && (
            <Typography
              sx={{
                ...stDesk.textLabel,
                color: pay === 'payMetod' ? 'black' : '#11c16d',
              }}
            >
              {text}
            </Typography>
          )}
        </Box>

        {confirmed ? (
          <Lottie animationData={checkAnimated} loop={false} style={{ minWidth: 24, height: 24 }} lottieRef={lottieRef} />
        ) : pay !== '' ? (
          <RadioButtonUncheckedIcon sx={{ color: 'gray', width: 20, height: 20 }} fontSize='small' />
        ) : (
          <BiChevronRight size={25} color='#DA5A34' />
        )}
      </Button>

      {disabled && unavailableMessage && (
        <Typography variant='caption' fontWeight='bold' sx={{ bgcolor: 'error.light', color: 'error.dark', borderRadius: 1, px: 0.5 }}>
          {unavailableMessage}
        </Typography>
      )}
    </Box>
  )
}
